/**
 * Created by devpatel on 3/4/14.
 */


"use strict";

var SoaModel = require('bunsen/models/SoaModel');
var SellerBillingProfile = SoaModel.extend();

module.exports = SellerBillingProfile; // this is where the magic happens

var Backbone = require('dibs-backbone');
var $ = require('dibs-jquery-shim');
var _ = require('underscore');
var Seller = require('bunsen/models/Seller');


var sellerBillingProfileURLFunction = function () {
    return _.result(this.findParent(Seller), 'url') + '/billingProfile';
};


/**
 * SellerCreditCard model is a child of Seller.billingProfile.
 * -- Note the seller's credit card number will alweays be masked when you request it from the server.
 */
var SellerCreditCard = SoaModel.extend({
    url : sellerBillingProfileURLFunction,

    initialize : function () {
        // When the combined expiration field is updated, update the fields used for actual persistence.
        this.on('change:expiration', this.updateDates);
    },

    defaults : {
        paymentMethodType : "CREDIT_CARD"
    },

    /**
     * Parse method for the credit card combines the month and date into 1 field, expiration:
     */
    parse : function (response) {
        // Get the expiration field by combining the month and year fields:
        if (response.cardExpiryMonth && response.cardExpiryYear) {
            response.expiration = response.cardExpiryMonth + ' / ' + response.cardExpiryYear;
        }

        return response;
    },

    /**
     * Splits the expiration field into 2 fields, month and year.
     * @param subView
     * @param value
     */
    updateDates : function (model, value) {
        var exp = value.split('/');
        var month =  $.trim(exp[0]);
        var year = $.trim(exp[1]);

        if (year.length === 4) {
            year = year.substr(2, 2);
        }

        this.set('cardExpiryMonth', month);
        // Force a two digit year
        this.set('cardExpiryYear', year);
    },

    relations: [
        {
            key: 'billingAddress',
            relatedModel: SoaModel,
            type: Backbone.One
        }
    ]
});


_.extend(SellerBillingProfile.prototype, {
    url : sellerBillingProfileURLFunction,

    defaults: {
        setupFee: 0,
        monthlyFee: 0,
        monthlyCycle: 1,
        payStatus : "CK"
    },

    /**
     * Over-ride the normal sync method to ignore the Credit Card's expiration field:
     */
    sync : function (method, model, options) {
        var attrs = options.attrs || this.toJSON();

        // Remove the creditCard.expiration attribute from the data representation.
        attrs = _.omit(attrs, ['feeStructure']);
        if (attrs.creditCard) {
            delete attrs.creditCard.expiration;
        }

        return SellerBillingProfile.__super__.sync.apply(this, [method, model, _.defaults({ attrs : attrs }, options)]);
    },
    relations: function () {
        return [
            {
                key: 'creditCard',
                relatedModel: SellerCreditCard,
                type: Backbone.One
            }
        ];
    }
});

_.extend(SellerBillingProfile, {
    STATUS_EXPIRED : 'EXPIRED',
    STATUS_DECLINED : 'DECLINED'
});



//////////////////
// WEBPACK FOOTER
// ./~/bunsen/models/identity/SellerBillingProfile.js
// module id = 2644
// module chunks = 63